import type { ManualPriceRequestView } from '@chukua/common';

interface ManualPriceActionsInput {
  pricingRequired: boolean;
  request: Pick<ManualPriceRequestView, 'status' | 'submittedById'> | null;
  userId: string | undefined;
  permissions: readonly string[];
}

/**
 * Which off-card price buttons to show. UX only: the server holds the real gate (`job.create`,
 * `pricing.approve_offcard` and the separation-of-duties rule), and the submitter never sees a decide button.
 */
export function manualPriceActions({ pricingRequired, request, userId, permissions }: ManualPriceActionsInput) {
  const isPending = request?.status === 'pending_approval';
  return {
    canSubmit: pricingRequired && !isPending && permissions.includes('job.create'),
    canDecide: pricingRequired && isPending && permissions.includes('pricing.approve_offcard') && request.submittedById !== userId,
  };
}
